import { ChevronDown } from 'lucide-react'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { WorkspaceTab } from '@/stores/app'

import { getTabIcon } from './tabIcon'

interface TabBarOverflowProps {
  tabs: WorkspaceTab[]
  onSelect: (id: string) => void
}

export function TabBarOverflow({ tabs, onSelect }: TabBarOverflowProps) {
  if (tabs.length === 0) return null
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="inline-flex h-10 items-center gap-1 px-4 text-sm text-black-alpha-11 hover:text-primary-high-contrast focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-solid focus-visible:ring-offset-2 rounded-t-xl"
        aria-label={`Show ${tabs.length} more tab${tabs.length === 1 ? '' : 's'}`}>
        <span>+{tabs.length}</span>
        <ChevronDown size={18} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-w-xs">
        {tabs.map((tab) => {
          const Icon = getTabIcon(tab.routeId)
          return (
            <DropdownMenuItem key={tab.id} onSelect={() => onSelect(tab.id)}>
              <span className="inline-flex items-center gap-2 min-w-0">
                {Icon && <Icon size={16} className="shrink-0" />}
                <span className="truncate">{tab.title}</span>
              </span>
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
